import Error404 from "assets/image/error404.png";
import Bg404 from "assets/image/bg404.png";
import Fork from "assets/image/fork.png";
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";

const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="fixed-background-404">
        <div className="d-flex flex-column align-items-center justify-content-center position-relative">
          <div className=" d-flex flex-column align-items-center justify-content-end mt-8">
            <img
              src={Error404}
              className="error-404-image"
              alt="page not found"
            />
            <span className="fw-bold pb-3 text-primary-light">
              {t("Page not found")}
            </span>
            <span className="px-5 text-center text-secondary-three-light pb-3">
              {t("This page may have been changed or deleted by another URL")}
            </span>
          </div>
        </div>
        <div className="d-flex flex-column">
          <img src={Fork} alt="page not found" />
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
